// Something shared into the app for a bot (native/intents.js): the message and files wait
// here until the new chat with that bot opens and puts them in its message box (BotPage).
let draft = null;

/** { botId (null: whichever bot the new chat starts with), text, files: File[] } */
export const putShareDraft = (next) => {
  draft = next;
  window.dispatchEvent(new Event('bb:share-draft'));
};

/** The draft for a new chat with `botId`, taken once; null when there is none for it. */
export const takeShareDraft = (botId) => {
  if (!draft || (draft.botId && draft.botId !== botId)) return null;
  const taken = draft;
  draft = null;
  return taken;
};
